export { DEFAULT_LANGUAGE, translation } from './language';
export * from './server';

export const FETCH_CONTINIOUS_INTERVAL = 60000;
export const PAGE_SIZE = 6;
export const SELECT_SIZE = 500;
// export const DOMAIN = 'wiserdoorweb.se.com:8060';
